<template>
    <div v-if="confirmState.open" class="simple-alert">
        <div class="simple-alert-box">
            <p style="white-space: pre-line">{{ confirmState.message }}</p>

            <div class="simple-alert-actions">
                <button class="btn-cancel" @click="resolveConfirm(false)">
                    {{ confirmState.cancelText }}
                </button>
                <button class="btn-ok" @click="resolveConfirm(true)">
                    {{ confirmState.okText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useAppAlert } from '@/composables/useAppAlert'
    const { confirmState, resolveConfirm } = useAppAlert()
</script>
<style scoped>
    .simple-alert{
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
    }
    .simple-alert-box{
        background: #fff;
        padding: 20px;
        border-radius: 12px;
        width: 480px;
    }
    .simple-alert-actions{
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 14px;
    }
    .btn-cancel{
        padding: 6px 16px;
        border-radius: 8px;
        border: 1px solid #cfd6e0;
        background: #fff;
        cursor: pointer;
    }
    .btn-ok{
        padding: 6px 16px;
        border-radius: 8px;
        border: none;
        background: #2f6bff;
        color: #fff;
        cursor: pointer;
    }
</style>
